module.exports = __webpack_public_path__ + "img/2.91ebe0ee.jpg";